import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container } from 'components/ui'
import s from './termos-e-condicoes-para-vendedores.module.css'

export default function TermosECondicoesParaVendedores() {
  const crums = [
    {
      label: 'Institucional',
    },
  ]
  return (
    <Layout>
      <Head>
        <title>Termos e Condições para Vendedores</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <Container>
        <h1 className={s.title}>Termos e Condições Gerais de Uso do Site para Vendedores</h1>
        <div className={s.root}>
          <p>
            <strong>Última atualização: 03 de novembro de 2016.</strong>
          </p>
          <p>
            Estes Termos e Condições Gerais de Uso regulam a utilização dos serviços oferecidos pela empresa CLAUDIAWEB
            CONSULTORIA DE INFORMAÇÕES EIRELI - ME, inscrita no CNPJ/MF sob o nº 22.816.619/0001-01, com sede na na Rua
            Antonio Simão da Costa nº 219, Industrial 4 Seção, Ibirité/MG, CEP 32.400-001, através do website
            www.fazendinha.me.
            <br />
          </p>
          <p>
            A leitura e aceitação dos termos abaixo são obrigatórias para o cadastro e uso dos serviços oferecidos pelo
            FAZENDINHA, seja como comprador ou vendedor. Se o VENDEDOR não concordar com os termos, não pode usar os
            serviços oferecidos pelo FAZENDINHA.
          </p>
          <p>
            Qualquer pessoa, doravante denominada USUÁRIO, que pretenda utilizar os serviços do FAZENDINHA, deverá
            aceitar os Termos e Condições Gerais de Uso do Site e todas as demais políticas e princípios que o regem.
          </p>
          <p>
            A ACEITAÇÃO DESTES TERMOS E CONDIÇÕES GERAIS DE USO É ABSOLUTAMENTE INDISPENSÁVEL À UTILIZAÇÃO DOS SITES E
            SERVIÇOS PRESTADOS PELO FAZENDINHA
          </p>
          <p>
            O USUÁRIO deverá ler, certificar-se de haver entendido e aceitar todas as condições estabelecidas no TERMO,
            assim como nos demais documentos incorporados aos mesmos por referência, antes de seu cadastro como Usuário
            do FAZENDINHA. Em caso de dúvidas, consulte a ajuda online.
          </p>
          <h3>
            <strong>Definições:</strong>
          </h3>
          <p>
            Neste TERMO, a menos que por outra forma expressamente disposto ou exigido em função do contexto, as
            expressões em letra maiúscula, no singular ou plural, terão os significados especificados abaixo:
            <br />
          </p>
          <p>ANÚNCIO – significa toda e qualquer oferta de produto veiculada no site https://fazendinha.me;</p>
          <p>COMPRADORES – significam os USUÁRIOS cadastrados no SITE quando realizando compras de produtos.</p>
          <p>
            FAZENDINHA – Conjunto de serviços de marketplace oferecido pela empresa CLAUDIAWEB CONSULTORIA DE
            INFORMAÇÔES EIRELI -ME, CNPJ/MF sob o nº 22.816.619/0001-01, no âmbito dos termos descrito neste TERMO;
          </p>
          <p>SITE – significa o site www.fazendinha.me;</p>
          <p>
            TERMO – significa o presente Termo e Condições Gerais de Uso;
            <br />
          </p>
          <p>
            USUÁRIOS – significam as pessoas físicas, maiores de 18 (dezoito) anos, ou pessoas jurídicas cadastradas
            para venderem ou comprarem mercadorias no SITE;
          </p>
          <p>
            VENDEDORES – significam os USUÁRIOS cadastrados no SITE e que estejam inserindo ANÚNCIOS de seus próprios
            produtos;
          </p>
          <h3>Para cadastrar:</h3>
          <p>
            Os serviços do FAZENDINHA estão disponíveis apenas para as pessoas que tenham capacidade legal para
            contratá-los. Não podem utilizá-los, assim, pessoas físicas que não gozem dessa capacidade, inclusive
            menores de idade, ou pessoas físicas e jurídicas que tenham sido inabilitadas pelo FAZENDINHA, temporária ou
            definitivamente, ficando, desde já, o USUÁRIO advertido das sanções legais do Código Civil, notadamente,
            art. 166, I; 171, I e 180 da lei n° 10.406/02.
          </p>
          <p>Pessoas Jurídicas poderão cadastrar-se por seus representantes legais.</p>
          <h3>Objeto:</h3>
          <p>
            Os serviços objeto do presente TERMOS consistem em ofertar e hospedar espaços no site www.fazendinha.me para
            que os vendedores anunciem seus próprios produtos, nos termos aqui descritos (doravante “VENDEDORES”), e
            viabilizar o contato direto entre VENDEDORES e Compradores, interessados em adquirir os produtos anunciados
            (doravante “COMPRADORES”). Portanto, o FAZENDINHA possibilita que os USUÁRIOS se contatem e negociem entre
            si diretamente, sem intervir na negociação ou na efetivação dos negócios, não sendo, nesta qualidade,
            fornecedor de quaisquer produtos ou serviços anunciados por seus VENDEDORES no site.
          </p>
          <p>Atualização e disponibilidade dos Termos e Condições Gerais de Uso do Site:</p>
          <p>
            O FAZENDINHA poderá alterar, a qualquer tempo, estes Termos e Condições Gerais de Uso do Site (“TERMO”),
            visando seu aprimoramento e melhoria dos serviços prestados. Os novos Termos e Condições entrarão em vigor
            10 dias após publicados no site caso não haja menção de outra data de efetivação do TERMO. O USUARIO que não
            concorde com os termos alterados, deverá comunicar sua discordância através do formulário
            <a href="https://fazendinha.me/contato/">https://fazendinha.me/contato</a>, no prazo de 30 (trinta) dias
            contados a partir da publicação das modificações. Nesse caso, a conta/perfil do USUARIO deixará de existir,
            desde que não haja contas ou dívidas em aberto. Não havendo manifestação no prazo estipulado, entender-se-á
            que o USUÁRIO aceitou tacitamente os novos Termos e Condições e o contrato continuará vinculando as partes.
          </p>
          <p>
            O FAZENDINHA manterá a versão atualizada destes Termos e Condições no endereço{' '}
            <a href="https://www.fazendinha.me/termos">https://fazendinha.me/termos</a> e o mesmo pode ser consultado a
            qualquer momento no endereço citado.
          </p>
          <h3>Descrição do serviço prestado pelo FAZENDINHA:</h3>
          <p>
            O FAZENDINHA é um serviço de divulgação e venda de produtos (alimentos e utensílios) sustentáveis, orgânicos
            e regionais na internet. O VENDEDOR pode divulgar e vender seus produtos através do FAZENDINHA, desde que
            sejam produtos produzidos pelo VENDEDOR, por uma equipe supervisionada diretamente pelo VENDEDOR ou por uma
            cooperativa ou associação da qual o VENDEDOR faça parte ou represente.
          </p>
          <h4>No FAZENDINHA é permitida a venda de:</h4>
          <ul>
            <li>Hortifruti</li>
            <li>Laticínios</li>
            <li>Grãos</li>
            <li>Farináceos</li>
            <li>Doces</li>
            <li>Molhos, conservas, temperos</li>
            <li>Bolos, biscoitos</li>
            <li>Carnes</li>
            <li>Bebidas (Cachaças, licores)</li>
            <li>Cosméticos naturais</li>
            <li>Utensílios</li>
            <li>artesanatos</li>
          </ul>
          <h4>No FAZENDINHA não é permitido:</h4>
          <ul>
            <li>Revenda de produtos ou serviços;</li>
            <li>Venda de produtos importados; </li>
            <li>Venda de produtos industrializados;</li>
            <li>
              Divulgação de produtos que infrinjam o direito de marcas registradas (ex.: uso de marcas, nomes
              comerciais, símbolos, logotipos, personagens, clubes de futebol, artistas, etc.);
            </li>
            <li>
              Uso de fotos, imagens, ilustrações ou textos de terceiros ou copiados da Internet, mesmo que sejam de
              fontes anônimas e/ou parcialmente utilizados (sujeito à análise da equipe do FAZENDINHA);
            </li>
            <li>
              Anunciar produtos que tenham sua comercialização proibida e/ou controlada no território brasileiro. bem
              como, mas não se limitando a (i) armas de fogo, armas brancas ou similares, pólvora ou material explosivo,
              narcóticos, tóxicos e qualquer sorte de drogas ilegais; (ii) medicamentos, qualquer tipo de drogas ou
              produtos aos quais se atribua efeitos terapêuticos de qualquer natureza; (iii) produtos roubados ou
              furtados, (iv) órgãos humanos e/ou de animais, no todo ou em parte, (v) moedas e cédulas falsificadas,
              (vi) produtos de contrabando, falsificados ou adulterados, bem como cópia ou réplica de produtos de
              terceiros, (vii) ações de empresas negociadas em Bolsa de Valores, bilhetes de loteria, listas de correio
              ou bases de dados pessoais, (viii) produtos relacionados à prostituição ou similares, material
              pornográfico, obsceno ou contrário a moral e os bons costumes, (ix) cigarros e outros produtos derivados
              do tabaco,(x) aparelhos ativos, eletroestimuladores, aparelhos e produtos para utilização em educação
              física, embelezamento e correção estética, que não estejam devidamente registrados e aprovados perante a
              Agência Nacional de Vigilância Sanitária e demais órgãos reguladores, (xi) CDs que contenham música em
              formato MP3, (xii) produtos que promovam a violência e/ou a discriminação baseada em questões de raça,
              sexo, religião, nacionalidade, orientação sexual ou de qualquer outro tipo, ou (xiii) bebidas em geral e
              produtos alimentícios.
            </li>
            <li>
              Os USUÁRIOS não poderão utilizar o SITE para: (i) instigar, ameaçar, ofender, abalar a imagem, violar a
              privacidade ou prejudicar outros; (ii) alterar e/ou copiar arquivos ou ainda obter senhas e dados de
              terceiros sem prévia autorização; (iii) desrespeitar a lei, a moral, os bons costumes, as normas de
              direito autoral e/ou propriedade industrial, os direitos à honra, à vida privada, à imagem, à intimidade
              pessoal e familiar; ou (iv) incitar a prática de atos discriminatórios, seja em razão de sexo, raça,
              religião, crenças, idade ou qualquer outra condição.
            </li>
          </ul>
          <h3>Serviços oferecidos pelo FAZENDINHA aos VENDEDORES:</h3>
          <h4>LOJA FAZENDINHA</h4>
          <p>
            Na loja FAZENDINHA, o VENDEDOR poderá cadastrar um número ilimitado de produtos, personaliza-la com banner,
            fachada e cadastrar um endereço personalizado (fazendinha.me/sualoja). Sua loja poderá aceitar pagamentos
            por cartões de crédito e boleto via Pagar.me.
          </p>
          <p>
            Os produtos cadastrados na loja aparecem nas buscas feitas no FAZENDINHA e nós trabalhamos na divulgação e
            visibilidade em redes sociais e sites de buscas da internet.
          </p>
          <h4>TAXA SOBRE VENDAS:</h4>
          <p>
            O FAZENDINHA retém um percentual do valor total da venda, acrescido de uma taxa por operação e mais o valor
            do frete, no momento que o comprador pagar pelo pedido. A taxa pela transação já está inclusa na taxa total.
          </p>
          <h4>DESTAQUE NA BUSCA:</h4>
          <p>
            Contratando o serviço o VENDEDOR poderá escolher até 16 produtos de sua loja para terem maior visibilidade
            nas buscas realizadas no FAZENDINHA. Os produtos que aparecerão em destaque na busca são os mesmos produtos
            selecionados pelo VENDEDOR nos “Produtos em destaque” de sua loja e podem ser alterados a qualquer momento.
            Sempre que a busca coincidir com as tags que o VENDEDOR cadastrou, seus produtos aparecerão nas primeiras
            páginas da lista de busca, aumentando com isso, suas chances de venda. O FAZENDINHA reserva-se o direito de
            ignorar tags cadastradas que não condizem com o produto anunciado. Para contratá-lo, acesse o menu Produtos
            &gt; Destaque na busca.
          </p>
          <p>
            O serviço de destaque na busca limita-se à promoção dos produtos nos resultados de busca. A contratação
            deste serviço não dá direito à exposição na página principal do FAZENDINHA ou divulgação nos emails
            marketing. Esse serviço não garante o sucesso nas vendas. Enquanto sua loja estiver em modo férias, seus
            produtos não aparecerão na busca.
          </p>
          <p>
            O FAZENDINHA não fará o reembolso de qualquer valor pago para lojas que forem suspensas por infringirem os
            Termos e Condições Gerais de Uso do Site.
          </p>
          <h3>Feiras e semelhantes:</h3>
          <p>
            O FAZENDINHA poderá promover a participação de seus lojistas em feiras e semelhantes, podendo estes ser
            pagos ou gratuitos.
          </p>
          <p>
            O FAZENDINHA apoia e orienta organização de eventos de sua comunidade de lojistas a partir de análise de
            projetos recebidos e acordo prévio e assinado entre os organizadores e esta empresa.
          </p>
          <h3>Compras e vendas pelo site:</h3>
          <p>
            O VENDEDOR concorda em se responsabilizar por seu próprio uso do serviço, por quaisquer compras, vendas ou
            postagens que fizer e por quaisquer consequências delas. Qualquer compra ou venda efetuada no site é de
            responsabilidade dos respectivos COMPRADORES e VENDEDORES, não podendo o FAZENDINHA ser responsabilizado por
            prejuízos decorrentes de atrasos, falta de pagamento, não entrega de produtos ou qualquer outro prejuízo
            gerado por VENDEDORES ou COMPRADORES que usam nosso serviço. O FAZENDINHA não respalda, apoia, representa
            nem garante a idoneidade, precisão ou confiabilidade do conteúdo postado por meio do serviço, muito menos
            respalda quaisquer opiniões expressas por meio do mesmo. O VENDEDOR reconhece e aceita quaisquer riscos ao
            confiar em material postado por meio do serviço.
          </p>
          <p>
            O VENDEDOR deve informar aos COMPRADORES o prazo de validade dos alimentos. Considerando tratar-se de
            produtos naturais e orgânicos, é de responsabilidade do COMPRADOR e do VENDEDOR garantir a adequada
            refrigeração no transporte e ao recebimento e a verificação da qualidade dos produtos antes do consumo. O
            FAZENDINHA não se responsabiliza por eventuais produtos estragados ou impróprios para consumo.
          </p>
          <h3>Políticas de Vendas:</h3>
          <ol className="ol1">
            <li>
              A conclusão dos pedidos no site FAZENDINHA deve ser feita da seguinte forma: Todo e qualquer pedido que
              for originado a partir do FAZENDINHA, tem obrigatoriamente que ser concluído pelo site, não sendo
              permitido que o VENDEDOR direcione o COMPRADOR para outros veículos para conclusão da venda, a saber:
              <ul>
                <li>
                  A comunicação entre VENDEDOR e COMPRADOR deve ocorrer da seguinte maneira: O FAZENDINHA oferece um
                  sistema de comunicação entre COMPRADOR e VENDEDOR para que todas as mensagens desde o primeiro contato
                  fiquem armazenadas no site e sejam enviadas ao e-mail do COMPRADOR e do VENDEDOR sem prejuízo nenhum
                  ao processo de comunicação atual. O registro destas comunicações via FAZENDINHA serve para o
                  FAZENDINHA manter um histórico completo dos pedidos dentro da plataforma desde o contato inicial e
                  também para determinar infrações às Políticas de Vendas com base nas mensagens trocadas.
                </li>
                <li>
                  A divulgação de informações por meio do FAZENDINHA deve ocorrer da seguinte maneira: Estão proibidas
                  as seguintes práticas de comunicação na loja (banner, fachada, produtos, mensagens ou qualquer página
                  hospedada pelo FAZENDINHA) listadas abaixo:
                  <ul>
                    <li>
                      Divulgação de outros domínios e lojas virtuais do vendedor que não o endereço de sua loja no
                      FAZENDINHA;
                    </li>
                    <li>Divulgação de blogs pessoais ou da loja;</li>
                    <li>
                      Divulgação de endereço pessoal ou da loja em redes sociais (Facebook, Twitter, Instagram, Flickr,
                      etc.);
                    </li>
                    <li>Divulgação de e-mail, telefone e/ ou endereço pessoal, loja ou ateliê;</li>
                    <li>
                      Divulgação de dados bancários do VENDEDOR para o COMPRADOR, a não ser via alguma operação
                      realizada via o site do FAZENDINHA.
                    </li>
                  </ul>
                </li>
                <li>
                  Adicionar em seus ANÚNCIOs acréscimos de preço caso o COMPRADOR opte por realizar o pagamento por um
                  determinado meio de pagamento.
                </li>
              </ul>
            </li>
            <li>
              A comissão sobre as vendas realizadas através do FAZENDINHA é efetuada nos termos abaixo:
              <ul>
                <li>Todas as vendas realizadas pelo FAZENDINHA são tarifadas;</li>
                <li>
                  As vendas geradas pelo FAZENDINHA podem ser concretizadas apenas com os meios de pagamento oferecidos
                  pelo site, a saber: Pagar.me (Cartão de crédito e Boleto);
                </li>
                <li>As cobranças de comissão são retidas no momento do pagamento do pedido pelo COMPRADOR.</li>
              </ul>
            </li>
          </ol>
          <h3>É obrigação do VENDEDOR:</h3>
          <ul>
            <li>
              Incluir dados reais e válidos em seu cadastro (Nome, CPF/ CNPJ, endereço e telefone), e mantê-los sempre
              atualizados.
            </li>
            <li>
              Realizar cadastro correto de seus produtos, informando valores, pesos, imagens e descrições coerentes com
              o que está sendo anunciado.
            </li>
            <li>Honrar seus pedidos, enviando-os dentro do prazo anunciado no ato da venda.</li>
            <li>
              Manter comunicação clara e direta com o COMPRADOR informando-o a respeito de todo o processo de venda.
            </li>
            <li>
              Informar ao consumidor sobre prazo de validade, condições do produto para consumo e recomendações sobre o
              armazenamento do produto, em especial a necessidade de refrigeração.
            </li>
            <li>
              Manter atualizado os dados peso e medida do pacote para cálculo do frete em cada produto, para utilizar o
              frete com desconto (PLP). Diferenças no valor calculado serão cobradas ao final de cada mês e a atenção e
              correção dos pesos e medidas informados são de responsabilidade do VENDEDOR. O frete com desconto é para
              uso exclusivo em pedidos concretizados no FAZENDINHA.
            </li>
            <li>
              Por uma determinação do novo{' '}
              <a href="https://www2.camara.leg.br/legin/fed/lei/2014/lei-12965-23-abril-2014-778630-norma-pl.html">
                <strong>marco civil da internet</strong>
              </a>
              , é obrigatório que o FAZENDINHA colete todas as informações de seus VENDEDORES para reportar às
              autoridades em caso de solicitação judicial. Os dados serão armazenados segundo nossos termos de
              confidencialidade e não serão repassados a terceiros sem o devido respaldo legal.
            </li>
            <li>Disponibilizar o meio de pagamento Pagar.me em sua loja</li>
          </ul>
          <p>
            Em virtude de o FAZENDINHA não figurar como parte nas transações de compra e venda de serviços e produtos
            que se realizam entre os Usuários, a responsabilidade por todas as obrigações delas decorrentes, sejam
            fiscais, trabalhistas, consumeristas ou de qualquer outra natureza, será exclusivamente do Usuário VENDEDOR.
          </p>
          <h3>Fica proibido ao usuário VENDEDOR:</h3>
          <ul>
            <li>Utilizar propagandas enganosas que possam induzir o usuário COMPRADOR a erro;</li>
            <li>Difamar, agredir ou injuriar outros usuários, sejam eles COMPRADORES ou VENDEDORES;</li>
            <li>Difamar a marca FAZENDINHA em qualquer página hospedada no FAZENDINHA ou em suas redes sociais;</li>
            <li>Desrespeitar a legislação nacional vigente;</li>
            <li className="li7">Divulgar dados de contatos do VENDEDOR através das páginas da loja ou de produtos;</li>
          </ul>
          <h4>É obrigação do COMPRADOR:</h4>
          <ul>
            <li>
              Colaborar com o VENDEDOR na providência de informações necessárias para o término do processo de venda;
            </li>
            <li>
              Manter comunicação clara e direta com o VENDEDOR a respeito de quaisquer modificações no pedido, problemas
              ou cancelamentos.
            </li>
            <li className="li7">
              Armazenar os produtos adequadamente no ato da entrega (por exemplo, evitar deixar os produtos na portaria
              por períodos prolongados)
            </li>
          </ul>
          <h3>Fica proibido ao usuário COMPRADOR:</h3>
          <ul>
            <li>Difamar, agredir, lesar ou injuriar outros usuários, sejam eles COMPRADORES ou VENDEDORES.</li>
            <li>Desrespeitar a legislação nacional vigente.</li>
            <li>
              Enviar seus dados pessoais aos VENDEDORES assim como solicitar os dados dos VENDEDORES. Apenas o envio de
              perguntas genéricas sobre o produto, prazo de entrega, elogios, valores e envio de CEP para cálculo de
              frete serão permitidos.
            </li>
          </ul>
          <p>O descumprimento destas proibições poderá acarretar notificação e inabilitação da conta do COMPRADOR.</p>
          <h3>Conteúdo publicado pelo Usuário:</h3>
          <p>
            O VENDEDOR concorda em postar apenas textos e fotos produzidos por si mesmo. O VENDEDOR declara que é autor
            ou que tem os direitos autorais de todo material que publicar no FAZENDINHA. O VENDEDOR concorda em não usar
            nomes de marcas registradas.
          </p>
          <p>
            O VENDEDOR autoriza que as imagens postadas nas avaliações de pedidos sejam exibidas ou compartilhadas
            publicamente no FAZENDINHA e nas redes sociais.
          </p>
          <h3>Responsabilidades do Usuário:</h3>
          <p>
            O VENDEDOR será o responsável por todas as atividades ocorridas com seu nome de Usuário e por manter a
            segurança de sua senha. O VENDEDOR entende e concorda que o serviço é fornecido a ele na forma em que se
            encontra e de acordo com a disponibilidade. O FAZENDINHA se isenta de qualquer responsabilidade e obrigação
            pela disponibilidade, pontualidade, segurança ou confiabilidade dos produtos anunciados no site, e também se
            reserva o direito de modificar, suspender ou encerrar o serviço com ou sem aviso prévio, a qualquer momento.
            O FAZENDINHA não monitora exaustivamente o conteúdo do site nem assume a responsabilidade por tal conteúdo,
            embora reserve-se o direito de notificar e inabilitar usuários que infringirem qualquer parte desses Termos
            e Condições Gerais de Uso do Site. Pelo contrário, o FAZENDINHA meramente fornece acesso a tal conteúdo na
            capacidade de prestador de um serviço ao VENDEDOR.
          </p>
          <p>
            O FAZENDINHA se reserva ao direito de não aprovar comentários no blog do FAZENDINHA:
            <a href="https://fazendinha.me/blog">https://fazendinha.me/blog</a>
          </p>
          <h3 className="p14">DISPONIBILIDADE DO PRODUTO</h3>
          <p className="p14">
            O VENDEDOR declara possuir o produto ofertado para entrega imediata, ou colocar de forma clara na oferta do
            seu produto o prazo para sua disponibilidade. Caso não possua o produto anunciado para entrega imediata ou
            não tenha expresso o prazo de disponibilidade, cabe ao VENDEDOR suspender/desativar temporariamente o
            ANÚNCIO até que o produto esteja disponível em seu estoque para pronta entrega. O VENDEDOR será o exclusivo
            responsável pelo não cumprimento da entrega do produto no prazo acordado com o COMPRADOR.
          </p>
          <p>
            O COMPRADOR declara ter conhecimento que os produtos anunciados podem ter estoques que são limitados e que,
            em algumas ocasiões, devido a causas dificilmente controláveis, como problemas nos sistemas informáticos e
            operações simultâneas, é possível que o produto não esteja disponível depois de ter sido realizado o pedido.
            Neste caso, o USUÁRIO será notificado pela equipe de atendimento sobre a anulação de seu pedido, sendo
            reembolsado pelos valores eventualmente já pagos.
          </p>
          <h3>Armazenamento de dados:</h3>
          <p>
            Não é permitida a utilização por parte dos Usuários de nenhum dispositivo, software ou outro recurso que
            venha a interferir nas atividades e operações do FAZENDINHA, bem como nos ANÚNCIOs, descrições, contas ou
            seus bancos de dados. Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie as leis de
            direito de propriedade intelectual e/ou as proibições estipuladas nestes Termos e Condições, tornarão o
            responsável passível das ações legais pertinentes, bem como das sanções aqui previstas, sendo ainda
            responsável pelas indenizações por eventuais danos causados.
          </p>
          <p>
            O VENDEDOR concorda que o FAZENDINHA não tem nenhuma responsabilidade pela exclusão, falha de armazenamento
            ou falha de transmissão de qualquer conteúdo ou outras comunicações mantidas pelo serviço. O FAZENDINHA
            reserva o direito de criar limitações de uso e armazenamento, a critério próprio, a qualquer momento e com
            ou sem aviso prévio.
          </p>
          <h3>Privacidade da Informação:</h3>
          <p>
            Toda informação ou dado pessoal prestado pelo USUÁRIO do FAZENDINHA é armazenada em servidores ou meios
            magnéticos de alta segurança. O FAZENDINHA tomará todas as medidas possíveis para manter a confidencialidade
            e a segurança descritas nesta cláusula, porém não responderá por prejuízo que possa ser derivado da violação
            dessas medidas por parte de terceiros que utilizem as redes públicas ou a internet, subvertendo os sistemas
            de segurança para acessar as informações de Usuários.
          </p>
          <p>
            O Usuário expressamente autoriza que suas informações e dados pessoais sejam compartilhados pelo FAZENDINHA
            com as demais empresas integrantes do grupo econômico.
          </p>
          <p>
            Em caso de dúvidas sobre a proteção a dados pessoais ou para obter maiores informações sobre dados pessoais
            e os casos nos quais poderá ser quebrado o sigilo de que trata esta cláusula, consultar nossa Política de
            Privacidade.
          </p>
          <h3>Envio de newsletter:</h3>
          <p>
            O FAZENDINHA poderá enviar ao seu e-mail ofertas de produtos e serviços e o COMPRADOR poderá a qualquer
            momento optar em não mais receber nossas ofertas. Para isso, basta clicar no link “descadastre-se” presente
            em todos os nossos e-mails.
          </p>
          <p>Conteúdo do serviço e Privacidade e Confidencialidade:</p>
          <p>
            O FAZENDINHA não assume responsabilidade pelo conteúdo de terceiros (incluindo, sem limitações, qualquer
            vírus ou outros elementos incapacitadores), nem tem qualquer obrigação de monitorar tal conteúdo de
            terceiros. O FAZENDINHA reserva o direito permanente de remover ou se recusar a distribuir qualquer conteúdo
            no serviço, como conteúdo que viole os termos deste contrato. O FAZENDINHA também se reserva o direito de
            acessar, ler, preservar e divulgar qualquer informação conforme acredite ser necessário para (a) satisfazer
            qualquer lei, regulamentação, processo legal ou solicitação governamental aplicável; (b) fazer cumprir este
            Contrato, incluindo a investigação de possíveis violações do mesmo; (c) detectar, impedir ou lidar com
            questões de fraude, segurança ou técnicas; (d) atender a pedidos de suporte do usuário ou (e) proteger os
            direitos, a propriedade ou a segurança do FAZENDINHA, seus usuários e o público.
          </p>
          <p>
            O FAZENDINHA poderá confirmar os dados pessoais informados e consultar entidades públicas, companhias
            especializadas ou bancos de dados, e está desde já expressamente autorizado. A informação que o FAZENDINHA
            obtiver destas entidades será tratada de forma confidencial. O FAZENDINHA coleta e armazena automaticamente
            algumas informações sobre a atividade dos Usuários cadastrados e visitantes de seu site.
          </p>
          <p>
            O FAZENDINHA poderá coletar e armazenar informação pessoal, como endereços de e-mails, caso os Usuários
            cadastrados (ou terceiros) enviem correspondências (sejam e-mails ou cartas) sobre as atividades ou sobre as
            mensagens de outros Usuários do site.
          </p>
          <p>
            O FAZENDINHA terá total acesso ao conteúdo das mensagens trocadas entre VENDEDORES e COMPRADORES, descrição
            dos produtos e das lojas e poderá, a qualquer momento e a seu exclusivo critério, editar ou bloquear seu
            conteúdo ou excluir o cadastro de qualquer VENDEDOR ou COMPRADOR, bem como advertir a respeito de troca de
            informações contrárias ao presente Termos e Condições.
          </p>
          <h3>Direitos de propriedade intelectual:</h3>
          <p>
            O VENDEDOR reconhece que o FAZENDINHA detém todos os direitos, títulos e interesses referentes ao serviço,
            incluindo todos os direitos de propriedade intelectual. Os direitos do FAZENDINHA estão protegidos por leis
            de propriedade intelectual nacionais e internacionais. Sendo assim, o VENDEDOR concorda que não copiará,
            reproduzirá, alterará, modificará ou criará produtos ou serviços derivados do serviço. O VENDEDOR também
            concorda que não utilizará nenhum robô, “spider”, outros dispositivos automatizados ou processos manuais
            para monitorar ou copiar conteúdo do serviço, sob pena de responder perante o FAZENDINHA pelas perdas e
            danos que causar, incluindo honorários advocatícios, quando necessários para a defesa dos interesses do
            FAZENDINHA.
          </p>
          <h3>Seus direitos de propriedade intelectual:</h3>
          <p>
            O FAZENDINHA não reivindica nenhum direito de propriedade ou controle sobre qualquer conteúdo enviado,
            postado ou exibido pelo VENDEDOR no serviço ou por meio dele. O VENDEDOR ou seu licenciador de direitos
            detém todas as patentes, marcas comerciais e direitos autorais de todo conteúdo enviado, publicado ou
            exibido nos serviços do O VENDEDOR ou por meio deles, e é responsável pela devida proteção desses direitos.
            Ao enviar, publicar ou exibir conteúdo nos serviços do FAZENDINHA, o VENDEDOR isenta de royalties e autoriza
            o FAZENDINHA a reproduzir, publicar e distribuir tal conteúdo. Além disso, o FAZENDINHA reserva o direito de
            não aceitar, publicar, exibir ou transmitir qualquer conteúdo de acordo com seus próprios critérios. O
            VENDEDOR declara e garante que tem todos os direitos, poderes e autoridade necessários para ceder os
            direitos aqui citados sobre qualquer conteúdo enviado.
          </p>
          <h3>Proibida a revenda do serviço:</h3>
          <p>
            O VENDEDOR concorda em não reproduzir, duplicar, copiar, vender, trocar, revender ou explorar com quaisquer
            fins comerciais (a) quaisquer parte do serviço, (b) o uso do serviço ou (c) o acesso ao serviço.
          </p>
          <h3>Declarações e garantias:</h3>
          <p>
            O VENDEDOR declara e garante que (a) todas as informações fornecidas por ele ao FAZENDINHA para participar
            do serviço estão corretas e atualizadas e que (b) ele tem todos os direitos, poderes e autoridade
            necessários para ingressar neste serviço e para executar os atos requeridos pelo mesmo.
          </p>
          <h3>Encerramento e Suspensão:</h3>
          <p>
            Sem prejuízo de outras medidas, o FAZENDINHA poderá advertir, suspender ou inabilitar, temporária ou
            definitivamente, a conta de um usuário, a qualquer tempo, e iniciar as ações legais cabíveis se:
          </p>
          <ul>
            <li>
              O usuário não cumprir qualquer dispositivo destes Termos e Condições Gerais e demais políticas do
              FAZENDINHA, incluindo, mas sem limitação qualquer tentativa de transmissão de dados pessoais através de
              mensagens;
            </li>
            <li>Se descumprir com seus deveres de usuário;</li>
            <li>Se praticar atos fraudulentos ou dolosos;</li>
            <li>
              Se não puder ser verificada a identidade do usuário ou qualquer informação fornecida por ele esteja
              incorreta;
            </li>
            <li>
              Se o FAZENDINHA entender que os ANÚNCIOs ou qualquer atitude do usuário tenham causado algum dano a
              terceiros ou ao próprio FAZENDINHA ou tenham a potencialidade de assim o fazer.
            </li>
            <li>Se não estiver em dia com suas faturas de comissão por vendas;</li>
            <li>Se o usuário solicitar a suspensão ou inabilitação de sua conta.</li>
          </ul>
          <p>
            Nos casos de suspensão ou inabilitação da conta do usuário, todos os ANÚNCIOs ativos serão automaticamente
            cancelados e a informação de que o usuário não pertence mais à comunidade FAZENDINHA poderá ser incluída na
            página do usuário. O usuário que teve sua conta inabilitada não será ressarcido de qualquer pagamento que
            tenha sido feito ao FAZENDINHA, independentemente do tempo decorrido entre o último pagamento e a
            inabilitação da conta.
          </p>
          <h3 className="p15">Comunicação entre os usuários</h3>
          <p>
            Todas as comunicações e negociações sobre produtos ofertados no FAZENDINHA e que se originem através do
            FAZENDINHA deverão necessariamente ser feitas dentro do próprio SITE. Não é permitido que o VENDEDOR
            direcione o COMPRADOR para outros veículos com a finalidade de concluir a venda fora do FAZENDINHA.
          </p>
          <p>
            A comunicação entre COMPRADOR e VENDEDOR poderá ficar armazenada no FAZENDINHA de forma a preservar um
            histórico completo dos pedidos realizados no FAZENDINHA e a verificação do cumprimento das políticas e
            regras aqui estabelecidas.
          </p>
          <p>
            O USUÁRIO aceita que não é permitido inserir ou manter no próprio ANÚNCIO ou na seção de perguntas e
            repostas, quaisquer dados pessoais para contato direto, sem intermediação do FAZENDINHA, tais como, mas não
            se limitando, a números de telefones, endereços de e-mails ou páginas de internet, bem como, dados bancários
            próprios ou de terceiros.
            <br />O USUÁRIO aceita que o FAZENDINHA poderá moderar a seção de perguntas e respostas e eliminar
            mensagens, palavras e expressões consideradas agressivas, caluniosas, injuriosas e difamadoras ou que violem
            qualquer outra regra do TERMO.
          </p>
          <p>
            A seção de perguntas e respostas não deverá ser usada como atendimento. Para se comunicar com o FAZENDINHA e
            solicitar atendimento, seja esse uma dúvida, problema, cancelamento, reporte de abuso ou outros, o usuário
            deverá acessar a seção de Ajuda.
          </p>
          <p>
            Caso queira desistir da compra o COMPRADOR deverá contatar o<br />
            VENDEDOR em até 7 dias após a compra, notificando sobre a desistência, para que não seja feito o envio do
            produto e em seguida enviar uma solicitação na Ajuda do FAZENDINHA informando o cancelamento
          </p>
          <p>
            Uma vez formalizado o cancelamento, os valores serão estornados, conforme condições descritas na política de
            Trocas e Devoluções.
          </p>
          <h3>Cancelamento dos serviços a pedido do usuário:</h3>
          <p>
            O usuário que quiser cancelar sua loja poderá fazê-lo, sendo que qualquer pagamento que tenha sido feito ao
            FAZENDINHA neste período não será ressarcido, independentemente do tempo decorrido entre o último pagamento
            e o cancelamento da loja.
          </p>
          <p>
            Para cancelar sua conta no FAZENDINHA, o usuário deverá entrar em sua loja e apagar todos os produtos,
            banner e fachada (este é um procedimento de segurança). Em seguida, deve avisar ao FAZENDINHA sobre tal
            procedimento <a href="https://fazendinha.me/contato/">preenchendo o formulário</a> com o assunto “Quero
            cancelar minha loja no Fazendinha”, que procederá ao cancelamento.
          </p>
          <p>
            Formas de Pagamento e Recebimento de valores pelos USUÁRIOS
            <br />
            As vendas geradas pelo SITE são efetivadas pela plataforma Pagar.me (
            <a href="https://pagar.me/" target="_blank" rel="noopener noreferrer">
              https://pagar.me
            </a>
            ) através da plataforma de serviços marketplace operacionalizada diretamente no SITE.
          </p>
          <p>
            O Pagar.me é uma ferramenta que permite o gerenciamento de valores recebidos e a efetivação de pagamentos
            online, para futuro repasse aos VENDEDORES após a efetivação da venda.
          </p>
          <p>
            A responsabilidade pela realização da transação financeira será exclusiva do Pagar.me de acordo com as
            regras e limitações do referido serviço, que devem ser verificados nos Termos e Condições Gerais de Uso do
            referido site.
          </p>
          <p>
            De modo a viabilizar e agilizar a realização de transações no site, o cadastro do USUÁRIO no SITE será
            compartilhado com o Pagar.me.
          </p>
          <p>
            Antes de prosseguir com a utilização do SITE o USUÁRIO deverá tomar ciência a respeito dos mecanismos de
            funcionamento do Pagar.me, disponível no site{' '}
            <a href="https://pagar.me/" target="_blank" rel="noopener noreferrer">
              https://pagar.me
            </a>
            .
          </p>
          <p>
            O cadastro dos VENDEDORES será compartilhado com o Pagar.me, a fim de que possam ser efetivados os
            pagamentos e reembolsos devidos em decorrência das transações contratadas no SITE.
          </p>
          <p>
            O USUÁRIO está ciente que os valores cobrados pelo uso da plataforma Pagar.me podem mudar a qualquer
            momento, a critério exclusivo do Pagar.me e o SITE não é responsável por essas alterações.
          </p>
          <p>
            Fica expressamente proibido o ANÚNCIO de outras formas de pagamento que não estiverem expressamente
            autorizadas pelo presente TERMO. Em caso de descumprimento deste item o ANÚNCIO será automaticamente
            excluído do SITE.
          </p>
          <p>
            Os valores pagos na aquisição dos produtos pelos COMPRADORES utilizando o meio de pagamento de Cartão de
            Crédito serão entregues aos VENDEDORES em 31 (trinta e um) dias corridos, desde que tenha passado 8 (oito)
            dias da confirmação do recebimento do produto pelo COMPRADOR ou comprovação da efetivação de entrega
            disponibilizada pelos Correios na consulta do código rastreador do objeto, o que ocorrer primeiro.
          </p>
          <p>
            Os valores pagos na aquisição dos produtos pelos COMPRADORES utilizando o meio de pagamento de Boleto serão
            entregues aos VENDEDORES em 2 (dois) dias úteis, desde que tenha passado 8 (oito) dias da confirmação do
            recebimento do produto pelo COMPRADOR ou comprovação da efetivação de entrega disponibilizada pelos Correios
            na consulta do código rastreador do objeto, o que ocorrer primeiro.
          </p>
          <p>
            Caso o VENDEDOR opte pelas formas de envio “frete grátis” ou “retirada no
            <br />
            local”, o SITE procederá com a transferência dos recursos nos mesmos moldes previstos acima.
          </p>
          <p>
            Caso o COMPRADOR não confirme o recebimento do produto, o SITE procederá com a transferência dos recursos
            mediante solicitação do VENDEDOR que deverá comprovar o envio através do Código de Rastreamento dos
            Correios. O COMPRADOR será notificado para confirmação do recebimento do produto dentro do prazo de 02
            (dois) dias úteis e, caso não se manifeste, os valores serão disponibilizados ao VENDEDOR.
          </p>
          <h3>Prazo de Envio e Extravios </h3>
          <h4>O VENDEDOR deverá informar no SITE as formas possíveis de entrega de seu produto.</h4>
          <p>
            Nos casos em que o COMPRADOR opte pela entrega que não seja por Correio, com exceção da retirada no próprio
            local, o VENDEDOR deverá cumprir com a data informada no SITE para a opção de entrega escolhida, contado a
            partir da data da venda.
          </p>
          <p>
            Exceto em casos em que os produtos não forem entregues via Correio, o VENDEDOR deverá enviar o produto para
            o endereço informado pelo COMPRADOR no prazo de 03 (três) dias úteis da data da venda, através de uma
            agencia dos Correios, utilizando a etiqueta disponível para impressão na tela “vendas” e no e-mail de
            confirmação de venda.
          </p>
          <p>
            Será de responsabilidade dos Correios o cumprimento do prazo de entrega estabelecido quando da postagem do
            produto, bem como nos casos de extravio. Em caso de extravio, o COMPRADOR será ressarcido dos valores pagos.
            Caso o VENDEDOR tenha optado pelo envio com seguro, também será feito o reembolso e para isso, ele deve
            entrar em contato com a Ajuda do SITE.
          </p>
          <p>
            O SITE não se responsabiliza pela entrega ou pelo estado do produto adquirido, nem possui obrigação de fazer
            com que o VENDEDOR cumpra com suas obrigações ou efetive a NEGOCIAÇÃO.
          </p>
          <h2>Devoluções </h2>
          <h3>
            Devoluções e Troca de produtos deverão seguir as orientações e restrições contidas nas políticas de Trocas e
            Devoluções.
          </h3>
          <h4>Isenção de responsabilidade:</h4>
          <p>
            O VENDEDOR concorda em isentar e desresponsabilizar o FAZENDINHA e suas afiliadas, representantes, agentes e
            funcionários de queixas de terceiros causadas pela ou relacionadas a sua utilização do serviço, incluindo
            qualquer responsabilidade ou despesa proveniente de queixas, perdas, danos (diretos e consequentes), ações
            judiciais, sentenças, despesas processuais ou honorários de qualquer tipo e natureza. Em tais casos, o
            FAZENDINHA o notificará por escrito quanto à queixa, ação judicial ou ao processo.
          </p>
          <p>
            O FAZENDINHA não se responsabiliza por eventuais diferenças nos valores informados e pagos pelo COMPRADOR ou
            VENDEDOR por conta de reajustes dos Correios. Os Correios podem realizar adequações nos preços dos serviços
            oferecidos a qualquer momento. Como consultamos os valores diretamente em sua base, poderão surgir
            alterações nos valores de frete no intervalo de tempo do cálculo ou estimativa do frete, a escolha e
            pagamento do frete pelo comprador e o pagamento do frete pelo vendedor.
          </p>
          <p>
            Qualquer postagem realizada por COMPRADORES e VENDEDORES utilizando o serviço dos Correios e/ou
            transportadoras é de responsabilidade única e exclusiva da empresa contratada, COMPRADORES e VENDEDORES, não
            podendo o FAZENDINHA ser responsabilizado por prejuízos decorrentes de perdas, furtos e danos decorrentes do
            uso destes serviços. O FAZENDINHA também não pode intermediar ou interferir nos procedimentos destas
            empresas.
          </p>
          <p>
            O FAZENDINHA é um intermediador de negócio, não sendo portanto, parte integrante das negociações de produtos
            e serviços realizadas entre os usuários, desta forma, a responsabilidade por todas as obrigações delas
            decorrentes, sejam fiscais, trabalhistas, consumeristas ou de qualquer outra natureza, será exclusivamente
            do VENDEDOR.
          </p>
          <p>
            Em razão de não ser o FAZENDINHA o proprietário dos produtos anunciados pelos USUÁRIOS, nem deter a posse
            dos itens anunciados e, ainda, não realizar as ofertas de venda nem intervir na entrega dos produtos, fica
            isento de qualquer responsabilidade advinda da negociação de tais produtos, incluindo mas não se limitando
            a: existência, quantidade, qualidade, estado, descrição, integridade ou legitimidade dos produtos
            oferecidos, adquiridos ou alienados pelos USUÁRIOS, assim como pela capacidade para contratar dos USUÁRIOS
            ou pela veracidade dos dados pessoais inseridos nos cadastros. O FAZENDINHA não outorga garantia por vícios
            ocultos ou aparentes nas negociações entre os USUÁRIOS, sendo certo que cada USUÁRIO conhece e aceita ser o
            único responsável pelos produtos que anuncia ou pelas ofertas que realiza. O VENDEDOR será o único e
            exclusivo responsável por quaisquer danos, indenizações e prejuízos decorrentes da utilização indevida de
            fotos e produtos publicados pelo VENDEDOR, devendo este indenizar e manter o SITE indene de quaisquer
            reclamações.
          </p>
          <p>
            O FAZENDINHA não se responsabiliza por vícios ou defeitos técnicos e/ou
            <br />
            operacionais oriundos do sistema do USUÁRIO ou de terceiros, inclusive do Pagar.me.
          </p>
          <p>
            Em nenhum caso o FAZENDINHA será responsável pelo lucro cessante ou por qualquer outro dano e/ou prejuízo
            que o USUÁRIO possa sofrer devido às negociações realizadas ou não realizadas através do SITE, ainda que
            decorrentes da conduta de outros USUÁRIOS do SITE.
          </p>
          <p>
            O FAZENDINHA não se responsabiliza pelas obrigações de natureza tributária que incidam sobre as negociações
            realizadas entre o COMPRADOR e o VENDEDOR, assim, o VENDEDOR que atue como comerciante, nos termos da lei em
            vigor, responsabilizar-se-á pela integridade das obrigações oriundas de suas atividades, notadamente pelos
            tributos incidentes.
          </p>
          <p>
            O FAZENDINHA não se responsabiliza por qualquer dano, prejuízo ou perda sofridos pelos USUÁRIOS em razão de
            falhas na Internet, no sistema ou no servidor utilizado pelo USUÁRIO, ou aqueles decorrentes de condutas de
            terceiros, de caso fortuitos ou de força maior. O FAZENDINHA também não será responsável por qualquer vírus
            que possa atacar o equipamento do USUÁRIO em decorrência do acesso, utilização ou navegação na Internet ou
            como consequência da transferência de dados, arquivos, imagens, textos ou áudio.
          </p>
          <p>
            O USUÁRIO indenizará o FAZENDINHA, suas filiais, empresas controladas, diretores, administradores,
            colaboradores, representantes e empregados por qualquer demanda promovida por outros usuários ou terceiros
            decorrentes de suas atividades no SITE ou por seu descumprimento do presente TERMO e demais políticas do
            SITE, ou pela violação de qualquer lei ou direito de terceiros incluindo honorários advocatícios.
          </p>
          <h3>Anexos:</h3>
          <p>
            São parte integrante e inseparável destes Termos e Condições os seguintes documentos e/ou seções do
            FAZENDINHA incorporados por referência, onde estão detalhadas as políticas e/ou Termos e Condições de
            diferentes serviços oferecidos pelo site.
          </p>
          <p>
            Disposições Gerais
            <br />
            Este TERMO não gera nenhum contrato de sociedade, de mandato, franquia ou relação de trabalho entre o SITE e
            o(s) USUÁRIO(s).
          </p>
          <p>
            O uso comercial da expressão site <a href="https://www.fazendinha.me">fazendinha.me</a> como marca, nome
            empresarial ou
          </p>
          <p>
            nome de domínio, bem como os conteúdos das telas relativas aos serviços do SITE assim como os programas,
            bancos de dados, redes, arquivos que permitem que o USUÁRIO acesse e use sua conta são propriedade do
            FAZENDINHA e estão protegidos pelas leis e tratados internacionais de direito autoral, marcas, patentes,
            modelos e desenhos industriais. O uso indevido e a reprodução total ou parcial dos referidos conteúdos são
            proibidos, salvo a<br />
            autorização expressa do FAZENDINHA.
          </p>
          <h3>Legislação Aplicável e Foro de eleição</h3>
          <p>
            Todos os itens destes Termos e Condições são regidos pelas leis vigentes na República Federativa do Brasil.
            Para todos os assuntos referentes à interpretação, ao cumprimento ou qualquer outro questionamento
            relacionado a estes Termos e Condições, as partes concordam em se submeter ao Foro da Comarca de Belo
            Horizonte.
          </p>
          <h3>Dados de Contato</h3>
          <p>Endereço: Rua Antonio Simão da Costa nº 219, Industrial 4 Seção, Ibirité/MG, CEP 32.400-001</p>
          <p>Em caso de dúvida, entre em contato através de nossa Central de Atendimento</p>
        </div>
      </Container>
    </Layout>
  )
}
